module.exports = __webpack_public_path__ + "media/icons/facebook-4664998184eb8d23f3a78cc98cc84a82.svg";